module.exports = __webpack_public_path__ + "static/media/YM60_4.cf4d864b.jpg";